import styled from 'styled-components';

import colors from '../../../../../styles/colors';

const RunBarRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 8px 0;
`;

const SelectionCount = styled.span`
  margin-right: auto;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
`;

const Hint = styled.span`
  font-size: 12px;
  color: ${colors.shades.secondary6};
`;

const Progress = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${colors.shades.secondary8};
`;

export {
  RunBarRow,
  SelectionCount,
  Hint,
  Progress,
};
